import * as React from 'react'
import Header from './header'
import Footer from './footer'

const Layout = ({ pageTitle, children }) => {
  return (
    <>
      <Header />
      <main class="main">
        {children}
      </main>
      <Footer />
    </>
  )
}

export default Layout